var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('my-app',{attrs:{"auth-rules":"supervisor","frame-rules":"admin","label":_vm.title,"limitation":"tenantOwnTermsOfService"}},[_c('v-container',{attrs:{"fluid":""}},[_c('tenant-own-terms-of-service',{staticClass:"mx-auto"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }